interface UaLike {
  on(event: 'disconnected' | 'registered', cb: () => void): void;
  start(): void;
}

export interface ReconnectDeps {
  backoffMs: number[];
  maxAttempts: number;
  onGiveUp: () => void;
}

export interface ReconnectHandle {
  attempts(): number;
}

export function attachReconnect(ua: UaLike, deps: ReconnectDeps): ReconnectHandle {
  let attempts = 0;
  ua.on('registered', () => { attempts = 0; });
  ua.on('disconnected', () => {
    if (attempts >= deps.maxAttempts) {
      deps.onGiveUp();
      return;
    }
    const delay = deps.backoffMs[Math.min(attempts, deps.backoffMs.length - 1)] ?? 30_000;
    attempts++;
    setTimeout(() => ua.start(), delay);
  });
  return { attempts: () => attempts };
}
